import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { UiEngineComponent } from '../base/components/ui-engine/ui-engine.component';
import { EmrComponent } from '../emr/components/emr.component';
import { OpprescriptionService } from '../emr/components/op-prescription/opprescription.service';
import { AsideBarService } from '../base/services/asideBar.service';
import { catchError, Observable, of, tap } from 'rxjs';


@Component({
    selector: 'app-hdrdata',
    templateUrl: '../base/components/ui-engine/ui-engine.component.html',
    styleUrls: ['../base/components/ui-engine/ui-engine.component.scss'],
    standalone: false
})
export class HDRDataComponent extends UiEngineComponent implements OnInit {
  data:any;
  action:any;
  resource: any; 
 constructor(
  public injector: Injector,
  public router: Router,
  public route: ActivatedRoute,
  public modal: BsModalService,
  public opPrescriptionService: OpprescriptionService,
  public asideBarService: AsideBarService
) {
  super(injector, router, route, modal);
}

  ngOnInit(): void {
    this.resourcename = this.resource['resource'];
    //  this.current_Resource = localStorage.CurrentResource;
    //   console.log("current_Resource"+ this.current_Resource);

    super.ngOnInit();
  }

  checkCatalagueConfigExists$() {
    console.log("inside checkCatalagueConfigExists");
    
    try {
      if(this._currentData && this._currentData.archiveConfig && this._currentData.archiveConfig.hide_catalogue_menu != undefined && this._currentData.archiveConfig.hide_catalogue_menu == true && this._currentData.archiveConfig.catalogue_code != undefined) {
        // wrap callback API into Observable
        return new Observable<any>((observer) => {
          this.preferenceService.checkCatalagueConfigExists(this._currentData, (respObj) => {
            try {
              if (respObj) {
                const resourceToFind = this._currentData?.resouceDef?.resource;
                if (resourceToFind) {
                  const matchedObj = respObj.loadArchiveConfig.list.find(
                    (item: any) => item?.resource && item.resource === resourceToFind
                  );
                  if (matchedObj) {
                    console.log('Found object:', matchedObj);
                    this._currentData.archiveConfig.selected = matchedObj;
                  } else {
                    console.log('No match found');
                  }
                } else {
                  console.log('Resource not found');
                }
              }
              observer.next(respObj);
              observer.complete();
            } catch (innerErr) {
              console.error('Error processing catalogue response:', innerErr);
              observer.next(null);
              observer.complete();
            }
          });
        }).pipe(
          catchError((err) => {
            console.error('Error in checkCatalagueConfigExists:', err);
            return of(null); // continue flow even if error occurs
          })
        );
      } else {
        return of(null); // directly continue if condition not met
      }
    } catch (err) {
      console.error('Outer error in checkCatalagueConfigExists:', err);
      return of(null);
    }
  }

  bindGrid(resource?, application?, type?, queryId?, printInfo?, callback = null) {
    this.checkCatalagueConfigExists$()
      .pipe(
        tap(() => {
          console.log('Catalogue check complete, now continuing...');
        })
      )
      .subscribe(() => {
        // continue with normal grid flow
        this.continuebindGrid(resource, application, type, queryId, printInfo);
      });
  }

  continuebindGrid(resource?, application?, type?, queryId?, printInfo?, callback = null) {
    this.loader.showSpinner();
    this.updateCurrentDataFromSavedFilter();
    var gridData = JSON.parse(JSON.stringify(this._currentData.gridData));//making a clone
    if (this._currentData.dataGridConfig.secondary_uhid_default) {
      gridData['args'] += "," + 'secondary_uhid:true';
    }
    if (this._currentData.dataGridConfig.ehr_view_default || this.ehr_view_default == true)
      gridData['read_scope_level'] = 'account';
    else if (gridData['read_scope_level'] != undefined)
      delete gridData['read_scope_level'];

    if (this._currentData.parameters) {
      gridData['parameters'] = this._currentData.parameters;
    }

    if (queryId == undefined || queryId == '') {
      gridData['query_id'] = this._currentData.query_id == undefined || this._currentData.query_id == "" ? "GET_PAGE" : this._currentData.query_id;
    } else { gridData['query_id'] = queryId == undefined || queryId == "" ? "GET_PAGE" : queryId; }


    if (this._layout_id && this._layout_data[this._layout_id] != undefined) {
      this._layout_data[this._layout_id]['grid_data'] = gridData;
    }
    if (this.route.snapshot.data.foreign_id != undefined && this.route.snapshot.data.foreign_id && this._currentData.currentForeignId) {  // this line is olny work for View_Details three dot click
      if (gridData.hasOwnProperty('filter') && gridData['filter'] != "") {
        gridData['filter'] += "," + this.route.snapshot.data.foreign_id + ':' + this._currentData.currentForeignId;
      } else {
        gridData['filter'] = this.route.snapshot.data.foreign_id + ':' + this._currentData.currentForeignId;
      }
    }
    try{
      if(this._currentData.summary){
        this._currentData.summary.hideSummaryButton = false;
      }
    }catch(error){}
    
    try {

      if ((this._currentData.gridData && this._currentData.gridData.projectionKeys) || (gridData.printInfo.actionType == "downloadCSV")) {
        gridData['projectionKeys'] = this._currentData.gridData.projectionKeys.toString();

      }
    } catch (error) { }

    if (gridData.order_by && gridData.search && gridData.search != undefined)
      delete gridData.order_by;

    //implementing print
    if (printInfo) {
      if (printInfo.contentType != 'byte_array') {
        printInfo.responseType = "blob";
        var gridTemplate = 'grid';
        if (printInfo.gridInfo != undefined && printInfo.gridInfo && printInfo.gridInfo.length > 0){
          let isTat = printInfo.gridInfo.find(s => s.name == 'tat');
          var tat = isTat != undefined && isTat? [ isTat.name ] : [];
        }
        if (this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.grid_template != undefined && this._currentData.resouceDef.config.grid_template != "") {
          gridTemplate = this._currentData.resouceDef.config.grid_template;
        }
        if (printInfo.print_data != undefined && printInfo.print_data == "grid" && printInfo.template != undefined) {
          gridTemplate = printInfo.template;
        }
        if (printInfo.args && printInfo.args != undefined) {
          var args = "reportTemplateId:" + gridTemplate + ",contentType:" + printInfo.file_type + "," + printInfo.args;
        }
        else {
          var args = "reportTemplateId:" + gridTemplate + ",contentType:" + printInfo.file_type;
        }
        if (this.appService.getCurrentLocation() && this.appService.getCurrentLocation().location_id != undefined) {
          args = args + ',location_id:' + this.appService.getCurrentLocation().location_id;
        }
        if (printInfo.actionType != undefined && ["downloadCSV", "download"].indexOf(printInfo.actionType) > -1) {
          args = args + ',downloadCSV:true';
        }
        if (printInfo.download_only != undefined && printInfo.download_only) {
          args = args + ',downloadOnly:true';
        }
        if (printInfo.chunk_download != undefined && printInfo.chunk_download) {
          args = args + ',chunk_download:true';
        }
        if (printInfo.chunk_size != undefined && printInfo.chunk_size) {
          args = args + ',chunk_size:'+printInfo.chunk_size;
        }
        
        if (this._currentData != undefined && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.exclude_fields != undefined && this._currentData.resouceDef.config.exclude_fields.length>0){
          printInfo.excludeFields = this.concatExcludeFieldFn(tat, this._currentData.resouceDef.config.exclude_fields);
        } else {
          printInfo.excludeFields = tat;
        }
        var tempO = this.utilService.applyArchiveArgs(printInfo,args,this);
        args = tempO.args;
        printInfo = tempO.printInfo;
        if (gridData.args != undefined && gridData.args != "") {
          if(args != undefined && args != ""){
            gridData.args = gridData.args + ',' + args;
          }
          
        } else {
          if(args != undefined && args != ""){
           gridData.args = args;
          }
        }
      }

      gridData.printInfo = printInfo;
      gridData.page_size = printInfo.page_size;
      // gridData.newPrint = printInfo.newPrint ? printInfo.newPrint : false;
      if (printInfo.amount != undefined) {
        gridData.amount = printInfo.amount;
      }
    } else {
      if (this.isDownloadOnly()) {
        this.loader.hideSpinner();
        return;//no API call is needed since only download of the data is allowed
      }
      /*************** NO COUNT IMPLEMENTATION *******************/
      var defaultNoCount = true;
      if (gridData["query_id"] != undefined && gridData["query_id"] == "GET_PAGE") {
        defaultNoCount = true;
      }
      this._currentData.dataGridConfig.noCount = this._currentData != undefined && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.noCount != undefined ? this._currentData.resouceDef.config.noCount : defaultNoCount;
      if (this._currentData.dataGridConfig.noCount != undefined && this._currentData.dataGridConfig.noCount) {
        var args = "noCount:1";
        if (gridData.args != undefined && gridData.args != "" && !gridData.args.includes("noCount")) {
          gridData.args = gridData.args + ',' + args;
        } else if (gridData.args != undefined && gridData.args != "" && gridData.args.includes("noCount")) {
          gridData.args = gridData.args;
        } else {
          gridData.args = args;
        }
      } else if (this._currentData.dataGridConfig.noCount != undefined && !this._currentData.dataGridConfig.noCount && gridData.args != undefined && gridData.args.includes("noCount")) {
        gridData.args = gridData.args.replace("noCount:1", "");
      }

      /*************** NO COUNT IMPLEMENTATION *******************/

      /*************** NO Rule IMPLEMENTATION *******************/
      if ((!this.ruleEngineService.config.resetFilter) && ((this.ruleEngineService != undefined && this.ruleEngineService.config != undefined && this.ruleEngineService.config.ruleInfo != undefined && this.ruleEngineService.config.ruleInfo) || (this._currentData != undefined && this._currentData.gridData != undefined && this._currentData.gridData['noRule'] != undefined && this._currentData.gridData['noRule']))) {
        if (gridData.args != undefined && gridData.args) {
          gridData.args = gridData.args + ',' + 'noRule:true';
        }
        else {
          gridData.args = 'noRule:true';
        }
        gridData['noRule'] = true;
      }

      try {

        if (this._currentData.saveFilterKey != undefined && this.persistGrid()) {
          delete this._currentData.saveFilterKey;
          this.saveFilterObj({ gridData: gridData }, (responseConfig) => {
            var queryObj = {};
            queryObj[responseConfig["filterSaveKey"]] = responseConfig["filterKey"];

            var url = this.router.createUrlTree([], { relativeTo: this.route, queryParams: queryObj, queryParamsHandling: 'merge' }).toString()
            this.locationCommon.replaceState(url);

            //this.router.onSameUrlNavigation = 'ignore';
            this.router.navigate(['.'], { relativeTo: this.route, queryParams: queryObj, replaceUrl: true, queryParamsHandling: 'merge' });//maintain history so that user could go back (uncommenting because router params was not updating)
          });
        }
        //  else{
        //    this.resetFilterKey();
        //  }
      } catch (e) {
        console.log(e);
        this._currentData.resouceDef.resource
      }

    }

    this.applyArchivePoicy(gridData, false);  
    if(this._currentData.resouceDef && this._currentData.resouceDef.config && this._currentData.resouceDef.config.encodeFilter && gridData.filter && gridData.filter != ''){
      gridData.filter = this.baseService.checkArgsandEncode(gridData.filter);
    }
    if (this._currentData != undefined && this._currentData.decorator != undefined && this._currentData.decorator) {
      this._currentData.decorator.bindGridExtended(gridData, resource, application, (val) => {
        gridData = val.gridData; resource = val.resource; application = val.application;
      });
    }
    //this will work for normal case
    if (!printInfo) {
      this.bindGridWithoutPrint(gridData, "", resource, application, callback);
    }
    //for print
    else if (printInfo) {
      this.bindGridWithPrint(gridData, "", resource, application, printInfo, callback);
    }
    else {
      //do nothing
    }
  }
}
